import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useLocation } from "react-router-dom";

function EditBlogField() {
  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [website, setField1] = useState("");
  const [id, setId] = useState("");
  const [BlogTitle, setBlogTitle] = useState("");
  const [BlogCategory, setField2] = useState("");
  const [publisher_name, setField3] = useState("");
  const [PublishingStatus, setStatus] = useState("");
  const [selectedImageURL, setSelectedImageURL] = useState("");
  const [imageOptions, setImageOptions] = useState([]);
  const [predefinedTags, setPredefinedTags] = useState([
    { tag: "gmart.in", selected: false },
    { tag: "network.gmart.in", selected: false },
    { tag: "automation.gmart.in", selected: false },
  ]);
  const navigate = useNavigate();
  const location = useLocation();

  let authtoken = localStorage.getItem("authToken");
    const handleKeyPress = (e) => {
    // debugger;
    if (e.key === "Enter" && inputValue.trim() !== "") {
      const newTag = inputValue.trim();

      // Check if the tag already exists in predefinedTags
      const isTagAlreadyPresent = predefinedTags.some(
        (item) => item.tag.toLowerCase() === newTag.toLowerCase()
      );

      if (!isTagAlreadyPresent) {
        // Add the new tag to predefinedTags and mark it as selected
        const newPredefinedTag = { tag: newTag, selected: true };
        setPredefinedTags([...predefinedTags, newPredefinedTag]);
        setTags([...tags, newTag]); // Add to selected tags
      } else {
        // If tag exists in predefinedTags, select it
        const updatedTags = predefinedTags.map((item) =>
          item.tag.toLowerCase() === newTag.toLowerCase()
            ? { ...item, selected: true }
            : item
        );
        setPredefinedTags(updatedTags);
        if (!tags.includes(newTag)) {
          setTags([...tags, newTag]);
        }
      }

      setInputValue("");
    }
  };
  // --- helper to normalize image item to URL string ---
  const imageItemToUrl = (item) => {
    // Accept either string or object (try common fields)
    if (!item) return "";
    if (typeof item === "string") return item;
    return item.url || item.publicUrl || item.key || item.path || item.Location || "";
  };

  // --- fetch media list (unchanged logic but make it robust) ---
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://cms.gmart.in/media-listing", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authtoken}`,
          },
          body: JSON.stringify({
            pageSize: 100,
            folderPrefix: "assets/GMart-Blogs-images",
          }),
        });
        const data = await response.json();
        // normalize to array of URLs
        const urls =
          Array.isArray(data.contents) && data.contents.length
            ? data.contents.map(imageItemToUrl).filter(Boolean)
            : [];
        setImageOptions(urls);
      } catch (error) {
        console.error("Error fetching media:", error);
      }
    };
    fetchData();
  }, [authtoken]);

  // --- NEW: load prefill data (from localStorage or navigation state) ---
  useEffect(() => {
    try {
      // 1) Check location.state (if you navigated with state) e.g., navigate('/edit', { state: post })
      const navState = location && location.state && location.state.post;
      let post = null;
      if (navState) {
        post = navState;
      } else {
        const stored = localStorage.getItem("updatedetails");
        if (stored) {
          post = JSON.parse(stored);
        }
      }

      const blogDetailsRaw = localStorage.getItem("blogdetails");
      let blogDetailsJSON = null;
      if (blogDetailsRaw) {
        try {
          blogDetailsJSON = JSON.parse(blogDetailsRaw);
        } catch (e) {
          // not valid json, ignore
          console.warn("blogdetails not valid JSON");
        }
      }
      const source = post || blogDetailsJSON;
      if (source) {
        if (source.website) setField1(source.website);
        if (source.BlogTitle) setBlogTitle(source.BlogTitle);
        if (source.BlogCategory) setField2(source.BlogCategory);
        if (source.coverImage) setSelectedImageURL(source.coverImage);
        if (source.id) setId(source.id);
      }
    } catch (err) {
      console.error("Error pre-filling data:", err);
    }
  }, [location]);

  const handleInputChange = (e) => setInputValue(e.target.value);
  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim() !== "") {
      const newTag = inputValue.trim();
      const isTagAlreadyPresent = predefinedTags.some(
        (item) => item.tag.toLowerCase() === newTag.toLowerCase()
      );

      if (!isTagAlreadyPresent) {
        const newPredefinedTag = { tag: newTag, selected: true };
        setPredefinedTags((prev) => [...prev, newPredefinedTag]);
        setTags((prev) => [...prev, newTag]);
      } else {
        setPredefinedTags((prev) =>
          prev.map((item) =>
            item.tag.toLowerCase() === newTag.toLowerCase() ? { ...item, selected: true } : item
          )
        );
        setTags((prev) => (prev.includes(newTag) ? prev : [...prev, newTag]));
      }
      setInputValue("");
    }
  };
  const handleField1Change = (e) => setField1(e.target.value);
  const handleField2Change = (e) => setField2(e.target.value);
  const handleField4Change = (e) => setBlogTitle(e.target.value);
  const handleField3Change = (e) => setField3(e.target.value);

  const handleRemoveTag = (indexToRemove) => {
    setTags((prev) => prev.filter((_, index) => index !== indexToRemove));
  };
  const togglePredefinedTag = (index) => {
    setPredefinedTags((prev) => {
      const updated = [...prev];
      updated[index].selected = !updated[index].selected;
      // update selected tag list accordingly
      const name = updated[index].tag;
      setTags((prevTags) =>
        updated[index].selected ? (prevTags.includes(name) ? prevTags : [...prevTags, name]) : prevTags.filter((t) => t !== name)
      );
      return updated;
    });
  };

  const handleSubmit = () => {
    if (!website || !BlogCategory || !BlogTitle || !selectedImageURL) {
      alert("All fields are mandatory, including tags and status.");
      return;
    }
    const data = { website, BlogCategory, BlogTitle, selectedImageURL, id };
    localStorage.setItem("updatedetails", JSON.stringify(data));
    navigate("/blogs/reactapps/edits");
  };

  return (
      <div className="container mt-5">
      <div className="col-md-4 mt-4">
        <h6><span style={{ color: "red" }}>*</span>Enter Blog Title</h6>
        <input
          type="text"
          className="form-control"
          placeholder="Enter Blog Title"
          value={BlogTitle}
          onChange={handleField4Change}
        />
      </div>

      <div className="col-md-8 mt-4">
        <h6><span style={{ color: "red" }}>*</span>Select Blog Cover Image</h6>
        <div className="dropdown">
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {selectedImageURL ? "Change Image" : "Select Image"}
          </button>
          <ul className="dropdown-menu" style={{ maxHeight: "300px", overflowY: "auto", width: 300 }}>
            {imageOptions.map((url, index) => (
              <li key={index} className="px-2 py-1" onClick={() => setSelectedImageURL(url)} style={{ cursor: "pointer" }}>
                <img src={url} alt={`Preview ${index}`} style={{ width: "200px", height: "auto" }} />
              </li>
            ))}
          </ul>
        </div>

        {selectedImageURL && (
          <div className="mt-2">
            <p className="mb-1"><strong>Selected Image:</strong></p>
            <img src={selectedImageURL} alt="Selected Preview" style={{ width: "120px", borderRadius: "8px" }} />
          </div>
        )}
      </div>


      {/* <div className="mt-3">
        {/* User-added Tags */}
      {/* <h5>Added Tags:</h5>
        {tags.map((tag, index) => (
          <span
            key={index}
            className="badge mx-1"
            style={{
              display: "inline-flex",
              alignItems: "center",
              padding: "10px",
              borderRadius: "20px",
              backgroundColor: "#add8e6", // Light blue background
              color: "black",
              fontWeight: "bold",
            }}
          >
            {tag}
            <button
              type="button"
              className="btn btn-sm btn-light ml-2"
              style={{ borderRadius: "50%", padding: "0 8px" }}
              onClick={() => handleRemoveTag(index)}
            >
              &times;
            </button>
          </span>
        ))}
      </div> */}



      <div className="col mt-4">
        {/* <div className="col-md-4">
          <h6><span style={{ color: "red" }}>*</span>Enter Website Name</h6>
          <input
            type="text"
            className="form-control"
            placeholder="Field 1"
            value={website}
            onChange={handleField1Change}
          />
        </div> */}
        <div className="col-md-4">
          <h6>
            <span style={{ color: "red" }}>*</span>Enter Website Name
          </h6>
          <select
            className="form-control"
            value={website}
            onChange={handleField1Change}
          >
            <option value="" disabled>
              Select Website
            </option>
            <option value="gmart.in">gmart.in</option>
            <option value="encriss.com">encriss.com</option>
            <option value="automation.gmart.in">automation.gmart.in</option>
            <option value="network.gmart.in">network.gmart.in</option>
            <option value="devices.encriss.com">devices.encriss.com</option>
            <option value="testing.in">testing.in</option>
            <option value="emprise.gmart.in">emprise.gmart.in</option>
            <option value="admin.gmart.in">admin.gmart.in</option>

          </select>
        </div>
        <br />
        <div className="col-md-4">
          <h6><span style={{ color: "red" }}>*</span>Enter Blog Category</h6>
          <input
            type="text"
            className="form-control"
            placeholder="Field 2"
            value={BlogCategory}
            onChange={handleField2Change}
          />
        </div>
        <br />
      </div>
      <button className="btn btn-primary mt-3" onClick={handleSubmit}>
        Submit Data
      </button>
    </div>
  );
}

export default EditBlogField;
